import React from 'react'
import FilterTableComponent from './FilterTableComponent'

const ListCmsfType = () => {
  return (
    <div>
      <FilterTableComponent/>
    </div>
  )
}

export default ListCmsfType